module.exports = __webpack_public_path__ + "img/cloud-fog.9a7a76ad.svg";